import { http } from "api/http";
import axios from "axios";

const getOrganizations = ({ queryKey }) => {
  return http.get(`/admin/organizations`, { params: { ...queryKey[1] } });
};

const getOrganization = ({ queryKey }) => {
  return http.get(`/admin/organizations/${queryKey[1]}`);
};

const getOrganizationUsers = ({ queryKey }) => {
  let orgId = queryKey[1].id;
  return http.get(`/admin/organizationUsers/${orgId}`, {
    params: { ...queryKey[1] },
  });
};

const updateOrganization = ({ id, data }: { id: number; data: any }) => {
  return http.put(`/admin/organizations/${id}`, data);
};

const getOrgNotificationConfig = ({ queryKey }) => {
  return http.get(`/admin/notificationConfig/${queryKey[1]}`);
};

const updateWhatsAppConfig = ({ id, data }) => {
  return http.put(`/admin/notificationConfig/${id}`, data);
};

const getAllOrganizationUsers = ({ queryKey }) => {
  return http.get(`/admin/allOrganizationUsers`, {
    params: { ...queryKey[1] },
  });
};

const getQuantumConfig = ({ queryKey }) => {
  return http.get(`admin/getQuantumConfig/${queryKey[1]}`);
};

const updateQuantumConfig = ({ id, data }) => {
  return http.put(`/admin/quantumConfig/${id}`, data);
};

const getQuantumRequests = ({ queryKey }) => {
  return http.get(`admin/quantumRequests`, { params: { ...queryKey[1] } });
};

const getAtomProMachines = ({ queryKey }) => {
  return http.get(`admin/atomProMachines`, { params: { ...queryKey[1] } });
};

const deleteAtomProServerMachines = (data) => {
  console.log(data);
  return http.put(`admin/atomProMachines`, data);
};

const upadteInqueueStatus = () => {
  return http.put(`admin/updateInqueueStatus`);
};

const deleteServerRowsAndChangeStatus = () => {
  return http.put(`admin/deleteServerRowsAndChangeStatus`);
};

const updateServerStatus = () => {
  return http.put(`admin/updateServerStatus`);
};

const getAutomationConfig = ({ queryKey }) => {
  return http.get(`admin/getAutomationConfig/${queryKey[1]}`);
};

const updateAutomationConfig = ({ id, data }) => {
  return http.put(`/admin/automationConfig/${id}`, data);
};

const getAuditConfig = ({ queryKey }) => {
  return http.get(`admin/getAuditConfig/${queryKey[1]}`);
};

const updateAuditConfig = ({ id, data }) => {
  return http.put(`/admin/auditConfig/${id}`, data);
};

const getAutomationScheduling = ({ queryKey }) => {
  return http.get(`/admin/automationScheduling/${queryKey[1]}`);
};

const updateGstrEnableStatus = ({ id }) => {
  return http.put(`/admin/gstrEnableStatus/${id}`);
};

const updateGstrDisableStatus = ({ id }) => {
  return http.put(`/admin/gstrDisableStatus/${id}`);
};

const updateIncometaxEnableStatus = ({ id }) => {
  return http.put(`/admin/incometaxEnableStatus/${id}`);
};

const updateIncometaxDisableStatus = ({ id }) => {
  return http.put(`/admin/incometaxDisableStatus/${id}`);
};

const organizationGstrScheduling = (data) => {
  return http.put(`/admin/scheduling`, data);
};

const getWhatsappRequests = ({ queryKey }) => {
  return http.get(`/whatsapp/requests`, { params: { ...queryKey[1] } });
};

const getAtomProLimitRequests = () => {
  return http.get(`admin/atomProLimitRequests`);
};

const responseForAtomProLimit = ({ id, data }) => {
  return http.put(`admin/atomProLimitRequests/${id}`, data);
};
const getViderConnectRequests = () => {
  return http.get(`admin/viderConnectRequests`);
};
const requestViderConnectAccess = (data: any) => {
  return http.post('/vider-connect/sendviderConnectRequest', data);
};

const getViderConnectAccessByOrg = (organizationId: number) => {
  return http.get(`admin/vider-connect-access/${organizationId}`);
};

const getViderConnectSubscription = (organizationId: number) => {
  return http.get(`/admin/subscription/${organizationId}`);
};

const updateViderConnectSubscription = ({
  organizationId,
  subscriptionEndsAt,
}: {
  organizationId: number;
  subscriptionEndsAt: string | null;
}) => {
  return http.post(`/admin/subscription/${organizationId}`, {
    subscriptionEndsAt,
  });
};

const getViderConnectMaxPhones = (organizationId: number) => {
  return http.get(`/admin/max-phones/${organizationId}`);
};

const updateViderConnectMaxPhones = ({
  organizationId,
  maxPhones,
}: {
  organizationId: number;
  maxPhones: number | null;
}) => {
  return http.post(`/admin/max-phones/${organizationId}`, {
    maxPhones,
  });
};

const getAtomproSummaryWhatsapp = (organizationId: number) => {
  return http.get(`admin/atompro-summary/${organizationId}`);
}
const updateAtomproSummaryWhatsapp = async (data: {
  organizationId: number;
  atomproSummary: boolean;
}) => {
  return http.post(
    `admin/update-atompro-summary`,
    data
  );
};

const getTallySyncEnabled = (organizationId: number) => {
  return http.get(`admin/tally-sync/${organizationId}`);
};
const updateTallySyncEnabled = async (data: {
  organizationId: number;
  isTallySyncEnabled: boolean;
}) => {
  return http.post(`admin/update-tally-sync`, data);
};

const getViderAuditRequests = () => {
  return http.get(`audit/viderAuditRequests`);
}

const updateViderAuditRequest = ({
  id,
  responseStatus,
}: {
  id: number;
  responseStatus: "PENDING" | "REJECTED" | "COMPLETED";
}) => {
  return http.put(`audit/viderAuditRequests/${id}`, { responseStatus });
};
export {
  getOrganizations,
  getOrganization,
  updateOrganization,
  getOrgNotificationConfig,
  updateWhatsAppConfig,
  getOrganizationUsers,
  getAllOrganizationUsers,
  getQuantumConfig,
  updateQuantumConfig,
  getQuantumRequests,
  getAutomationConfig,
  updateAutomationConfig,
  getWhatsappRequests,
  getAtomProLimitRequests,
  responseForAtomProLimit,
  getAutomationScheduling,
  organizationGstrScheduling,
  updateGstrDisableStatus,
  updateGstrEnableStatus,
  updateIncometaxEnableStatus,
  updateIncometaxDisableStatus,
  getAtomProMachines,
  deleteAtomProServerMachines,
  upadteInqueueStatus,
  updateServerStatus,
  deleteServerRowsAndChangeStatus,
  getViderConnectRequests,
  requestViderConnectAccess,
  getViderConnectAccessByOrg,
  getViderConnectSubscription,
  updateViderConnectSubscription,
  getViderConnectMaxPhones,
  updateViderConnectMaxPhones,
  getAtomproSummaryWhatsapp,
  updateAtomproSummaryWhatsapp,
  getTallySyncEnabled,
  updateTallySyncEnabled,
  getAuditConfig,
  updateAuditConfig,
  getViderAuditRequests,
  updateViderAuditRequest
};
